<script lang="ts">
	// Open WebUI `common/Spinner.svelte`: a 24×24 ring at 25% opacity with a
	// rotating arc in currentColor. Sized by the caller (`size-3` … `size-5`).
	let { class: className = 'size-4' }: { class?: string } = $props();
</script>

<svg class="{className} animate-spin" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
	<path
		d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
		opacity="0.25"
	/>
	<path d="M12 4C7.58172 4 4 7.58172 4 12H2C2 6.47715 6.47715 2 12 2V4Z" />
</svg>
